import React from 'react'
import useStore from '@/stores/useStore'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog'
import AppDocs from '@/components/AppDocs'
import FeatureLockDialog from '@/components/FeatureLockDialog'

const DIALOG_COPY = {
  docs: {
    title: 'Documentation',
    description: 'Full feature guides and calculation methodology.',
    content: <AppDocs />,
    className: 'max-w-5xl',
  },
}

// Dialogs that exist for everyone but require an account to open. Signed-out
// users see the reusable FeatureLockDialog instead of the real content. Add a
// dialog key here to gate it; the value is the copy shown in the lock popup.
const GATED_DIALOGS = {
  docs: {
    title: 'Log in to view the documentation',
    description: 'The full feature guides and calculation methodology are available to signed-in users.',
  },
}

export default function UtilityDialogs({ isAuthenticated = false, loginHref = null }) {
  const utilityDialog = useStore((state) => state.utilityDialog)
  const closeUtilityDialog = useStore((state) => state.closeUtilityDialog)

  const lock = GATED_DIALOGS[utilityDialog]
  if (lock && !isAuthenticated) {
    return (
      <FeatureLockDialog
        open
        onOpenChange={(open) => !open && closeUtilityDialog()}
        title={lock.title}
        description={lock.description}
        loginHref={loginHref}
      />
    )
  }

  const dialog = DIALOG_COPY[utilityDialog]
  const content = dialog?.content

  return (
    <Dialog open={Boolean(dialog)} onOpenChange={(open) => !open && closeUtilityDialog()}>
      {dialog && (
        <DialogContent className={`${dialog.className} max-h-[86dvh] overflow-hidden`}>
          <DialogTitle className="sr-only">{dialog.title}</DialogTitle>
          <DialogDescription className="sr-only">{dialog.description}</DialogDescription>
          {content}
        </DialogContent>
      )}
    </Dialog>
  )
}
